import { render } from "./FeatureDetails.vue?vue&type=template&id=57d29d06&ts=true"
import script from "./FeatureDetails.vue?vue&type=script&lang=ts"
export * from "./FeatureDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__